"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class ContainsValidator {
    constructor(seed) {
        this.seed = seed;
    }
    isValid(input) {
        if (input) {
            return validatorJS.contains(input, this.seed);
        }
        else {
            return false;
        }
    }
}
exports.ContainsValidator = ContainsValidator;
//# sourceMappingURL=ContainsValidator.js.map